import React from 'react';

import DatabaseIcon from '@atlaskit/icon/core/database';

import { i18n as databaseI18n } from './PromptDatabase.tsx';
import { PromptContent } from './PromptContent.tsx';
import { usePageAnalyticsAttributes } from './usePageAnalyticsAttributes.ts';

export interface DatabaseNudgeContentProps {
	competitorName: string;
	linkType?: string;
	editorAppearance?: string;
	onClickAction: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void>;
	onDismiss: () => void;
}

export const DatabaseNudgeContent: React.FC<DatabaseNudgeContentProps> = ({
	competitorName,
	linkType,
	editorAppearance,
	onClickAction,
	onDismiss,
}) => {
	const pageAnalyticsAttributes = usePageAnalyticsAttributes();

	return (
		<PromptContent
			titleText={databaseI18n.titleDatabase}
			descriptionText={databaseI18n.descriptionDefaultDatabase}
			ctaText={databaseI18n.createButtonDefaultDatabase}
			dismissText={databaseI18n.dismissButtonDatabase}
			contentIcon={DatabaseIcon}
			iconColor="purpleBold"
			iconAltText={databaseI18n.databaseIconAltText}
			onClickAction={onClickAction}
			contentType="database"
			onDismiss={onDismiss}
			competitorName={competitorName}
			linkType={linkType}
			editorAppearance={editorAppearance}
			pageAnalyticsAttributes={pageAnalyticsAttributes}
		/>
	);
};
